import { jsxs as t, jsx as l } from "react/jsx-runtime";
const s = ({ className: r, width: e = "37", height: o = "36" }) => /* @__PURE__ */ t(
  "svg",
  {
    className: r,
    width: e,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37 36",
    fill: "none",
    children: [
      /* @__PURE__ */ l(
        "path",
        {
          d: "M0 18c0 9.941 8.283 18 18.5 18S37 27.941 37 18 28.717 0 18.5 0 0 8.059 0 18Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ l(
        "path",
        {
          d: "M9.366 17.672c4.966-2.105 8.277-3.493 9.934-4.164 4.73-1.914 5.714-2.247 6.354-2.258.141-.002.456.032.66.193.173.136.22.32.243.449.023.129.051.423.029.652-.257 2.621-1.366 8.981-1.93 11.917-.24 1.242-.71 1.658-1.165 1.699-.989.088-1.74-.636-2.698-1.247-1.5-.957-2.346-1.552-3.802-2.485-1.682-1.078-.591-1.671.367-2.64.25-.253 4.61-4.11 4.694-4.46.01-.044.02-.207-.08-.294-.099-.086-.246-.056-.352-.033-.15.033-2.546 1.574-7.186 4.621-.68.454-1.295.676-1.847.664-.608-.013-1.778-.335-2.648-.61-1.067-.337-1.915-.515-1.84-1.088.038-.299.46-.604 1.267-.916Z",
          fill: "#fff"
        }
      )
    ]
  }
);
export {
  s as default
};
